import axios from 'axios';
import { constHostAddressConfig } from './constData';

const axiosClient = axios.create({
    baseURL: constHostAddressConfig.ApiTTDNAdress,
    headers: {
        'Content-Type': 'application/json',
    }
})
// API:  Y/N: Cau hinh su dung TT doanh nghiep.
export const getSysParam_OnOffTTDN = (ticker) => {
    return axiosClient.get(`/api/sysparam/${ticker}`);
};

// Tab Hồ Sơ
// /api/  cho nay sau doi thanh cf, hay gi do. Sau chia tải
export const getProfile = (ticker) =>{
    return axiosClient.get(`/api/GetProfile/${ticker}`);
};

// Tab Hồ Sơ
// lấy theo async
export const getProfileAsync = async (ticker) => {
    const res = await axiosClient.get(`/api/GetProfile/${ticker}`);
    // console.log('getProfile', res);
    return res.data;
};

// ___Tab Cổ Đông
export const getICShareHolder_ByOrancode = (ticker) => {
    return axiosClient.get(`/api/GetICShareHolder/${ticker}`);
};
//-- Biểu đồ
export const getOwnershipChart_ByOrancode = (ticker) => {
    return axiosClient.get(`/api/GetOwnershipChart/${ticker}`);
};
// ___End Tab Cổ Đông

// ___Tab Cổ Tức
export const getEvent_ByOrancode = (ticker) => {
    return axiosClient.get(`/api/GetEvent/${ticker}`);
};
//-- Biểu đồ
export const getEventChart_ByOrancode = (ticker) => {
    return axiosClient.get(`/api/GetEventChart/${ticker}`);
};
// ___End Tab Cổ Tức

// Tab Tài Chính
export const getRatio_ByOrancode = (ticker) => {
    return axiosClient.get(`/api/GetRatio/${ticker}`);
};